module.exports = __webpack_public_path__ + "img/45.f10baf30.png";